<form novalidate>
	<div class="p-3 bg-green color-white">
		<p class="small uc text-center mb-0">Modification de votre mot de passe<br/>Mares Libellules</p>
	</div>
	<div class="pt-4 pb-3 px-3 bb">
		<?-user.getFormError()?>

		<div class="form-group pb-2">
			<?-user.getFormField('password','Nouveau mot de passe',{type:'password'},{class:'fw-600 is-required'})?>
		</div>

		<div class="form-group">
			<?-user.getFormField('confirm','Confirmez le mot de passe',{type:'password'},{class:'fw-600 is-required'})?>
		</div>
	</div>
	<div class="p-3">
		<p class="text-center mb-0">
			<button type="submit" class="btn btn-lg btn-green btn-block">Enregistrer le mot de passe</button>
		</p>
	</div>
</form>
